/**
 * @Date: 2023-01-09 11:16:14
 * @FilePath: /actdianyuan/src/router/router2023.js
 * @Author: zwy
 * @Description:
 */
const Act2022 = [
    // 是德台式电源
    {
        path: "/keysight230109/index",
        name: "keysight230109",
        component: (resolve) =>
            require(["@/act2023/keysight230109/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    // 是德台式电源资料下载
    {
        path: "/keysight230109/download",
        name: "keysight230109Download",
        component: (resolve) =>
            require(["@/act2023/keysight230109/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // adi白皮书
    {
        path: "/adi230214/index/:id?",
        name: "adi230214",
        component: (resolve) => require(["@/act2023/adi230214/index.vue"], resolve),
        meta: {
            title: "ADC和DAC的基本架构",
        },
    },
    {
        path: "/adi230214/index/:page_identify/:identify",
        name: "adi230214",
        component: (resolve) => require(["@/act2023/adi230214/index.vue"], resolve),
        meta: {
            title: "ADC和DAC的基本架构",
        },
    },
    // 是德--三代半导体电路动态电流测量与分析
    {
        path: "/keysight230227/index",
        name: "keysight230227",
        component: (resolve) =>
            require(["@/act2023/keysight230227/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230227/download",
        name: "keysight230227Download",
        component: (resolve) =>
            require(["@/act2023/keysight230227/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // 是德--信果--小视频
    {
        path: "/keysight230303/index/:page_identify?",
        name: "keysight230303",
        component: (resolve) =>
            require(["@/act2023/keysight230303/index.vue"], resolve),
        meta: {
            title: "分流器、绝缘材料与传感器的测试",
        },
    },
    // 是德--康祺--小视频
    {
        path: "/keysight230304/index/:page_identify?",
        name: "keysight230304",
        component: (resolve) =>
            require(["@/act2023/keysight230304/index.vue"], resolve),
        meta: {
            title: "光伏逆变器与储能系统",
        },
    },
    // 是德--精测--小视频
    {
        path: "/keysight230305/index/:page_identify?",
        name: "keysight230305",
        component: (resolve) =>
            require(["@/act2023/keysight230305/index.vue"], resolve),
        meta: {
            title: "电源模块和功率器件评估",
        },
    },
    // 放大缩小
    {
        path: "/testscaleimage",
        name: "testscaleimage",
        component: (resolve) =>
            require(["@/act2023/testscaleimage/index.vue"], resolve),
        meta: {
            title: "测试页",
        },
    },
    // MPS 活动
    {
        path: "/MPS230323",
        name: "testscaleimage",
        component: (resolve) => require(["@/act2023/MPS230323/index.vue"], resolve),
        meta: {
            title: "MPS以太网供电(POE)产品解决方案",
        },
    },
    // MPS 活动回调页
    {
        path: "/MPS230323callback",
        name: "testscaleimage",
        component: (resolve) =>
            require(["@/act2023/MPS230323callback/index.vue"], resolve),
        meta: {
            title: "MPS以太网供电(POE)产品解决方案",
        },
    },
    // 是德--开关电源性能分析与优化
    {
        path: "/keysight230410/index",
        name: "keysight230410",
        component: (resolve) =>
            require(["@/act2023/keysight230410/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230410/download",
        name: "keysight230410Download",
        component: (resolve) =>
            require(["@/act2023/keysight230410/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // 是德--经济型电池测试及模拟方案
    {
        path: "/keysight230427/index",
        name: "keysight230427",
        component: (resolve) =>
            require(["@/act2023/keysight230427/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230427/download",
        name: "keysight230427Download",
        component: (resolve) =>
            require(["@/act2023/keysight230427/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // 论坛登录页
    {
        path: "/bbsadmintest/login",
        name: "bbslogin",
        component: (resolve) => require(["@/act2023/bbsadmin/login"], resolve),
        meta: {
            title: "论坛登录页",
        },
    },
    // 论坛筛选页
    {
        path: "/bbsadmintest/shaixue",
        name: "bbslogin",
        component: (resolve) => require(["@/act2023/bbsadmin/shaixuan"], resolve),
        meta: {
            title: "论坛登录页",
        },
    },
    // 汽车电子技术
    {
        path: "/car20230508/index",
        name: "car20230508",
        component: (resolve) => require(["@/act2023/car20230508"], resolve),
        meta: {
            title: "汽车电子技术大作战",
        },
    },
    // 是德--精测--小视频
    {
        path: "/keysight230522/index/:page_identify?",
        name: "keysight230303",
        component: (resolve) =>
            require(["@/act2023/keysight230522/index.vue"], resolve),
        meta: {
            title: "测试自动化和多路数据采集",
        },
    },
    // 是德--康祺--小视频
    {
        path: "/keysight230523/index/:page_identify?",
        name: "keysight230304",
        component: (resolve) =>
            require(["@/act2023/keysight230523/index.vue"], resolve),
        meta: {
            title: "新产品与新功能展示",
        },
    },
    // 是德--实拓--小视频
    {
        path: "/keysight230524/index/:page_identify?",
        name: "keysight230305",
        component: (resolve) =>
            require(["@/act2023/keysight230524/index.vue"], resolve),
        meta: {
            title: "新产品与新功能展示",
        },
    },
    // 是德--电流测量笔记3——动态电流高速测量和长时间记录
    {
        path: "/keysight230606/index",
        name: "keysight230606",
        component: (resolve) =>
            require(["@/act2023/keysight230606/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230606/download",
        name: "keysight230606Download",
        component: (resolve) =>
            require(["@/act2023/keysight230606/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // 慕尼黑上海电子展
    {
        path: "/electronica230612/index",
        name: "electronica230612",
        component: (resolve) =>
            require(["@/act2023/electronica230612/index.vue"], resolve),
        meta: {
            title: "融合创新 智引未来 | 与电源网一起开启2023慕展之旅",
        },
    },
    {
        path: "/electronica230612/details/:id",
        name: "electronica230612Details",
        component: (resolve) =>
            require(["@/act2023/electronica230612/details.vue"], resolve),
        meta: {
            title: "详情页",
        },
    },
    {
        path: "/waizhan2023/index",
        name: "waizhan2023",
        component: (resolve) =>
            require(["@/act2023/waizhan2023/index.vue"], resolve),
        meta: {
            title: "客服二维码",
        },
    },
    // 07.21是德直播资料分享
    {
        path: "/keysight230718/index",
        name: "keysight230718",
        component: (resolve) =>
            require(["@/act2023/keysight230718/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230718/download",
        name: "keysight230718Download",
        component: (resolve) =>
            require(["@/act2023/keysight230718/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // 是德--精测--小视频--q4
    {
        path: "/keysight230814/index/:page_identify?",
        name: "keysight230814",
        component: (resolve) =>
            require(["@/act2023/keysight230814/index.vue"], resolve),
        meta: {
            title: "低功耗物联网终端的器件、材料和整机的测试",
        },
    },
    // 是德--康祺--小视频--q4
    {
        path: "/keysight230815/index/:page_identify?",
        name: "keysight230815",
        component: (resolve) =>
            require(["@/act2023/keysight230815/index.vue"], resolve),
        meta: {
            title: "新能源汽车/车载电子",
        },
    },
    // MPS--企业报名表单
    {
        path: "/mps230901/index/:page_identify?",
        name: "mps230901",
        component: (resolve) => require(["@/act2023/mps230901/index.vue"], resolve),
        meta: {
            title: "MPS企业报名表单",
        },
    },
    // 09.06是德直播资料分享
    {
        path: "/keysight230906/index",
        name: "keysight230906",
        component: (resolve) =>
            require(["@/act2023/keysight230906/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight230906/download",
        name: "keysight230906Download",
        component: (resolve) =>
            require(["@/act2023/keysight230906/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    // MPS 活动
    {
        path: "/mps20230911/index",
        name: "mps20230911Index",
        component: (resolve) => require(["@/act2023/mps20230911/index"], resolve),
        meta: {
            title: "MPS智慧储能,引领未来",
        },
    },
    // 是德EXR示波器——混合信号测试的御林军刀
    {
        path: "/keysight231016/index",
        name: "keysight231016",
        component: (resolve) =>
            require(["@/act2023/keysight231016/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight231016/download",
        name: "keysight231016Download",
        component: (resolve) =>
            require(["@/act2023/keysight231016/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
    //东方中科
    {
        path: "/keysightzhong231124/index",
        name: "keysightzhong231124",
        component: (resolve) =>
            require(["@/act2023/keysightzhong231124/index.vue"], resolve),
        meta: {
            title: "东方中科分流器,绝缘材料与传感器的测试",
        },
    },
    // 上海信果
    {
        path: "/keysightguo231124/index",
        name: "keysightguo231124",
        component: (resolve) =>
            require(["@/act2023/keysightguo231124/index.vue"], resolve),
        meta: {
            title: "上海信果电源模块和功率器件评估",
        },
    },
    // 精测
    {
        path: "/keysightjingce231124/index",
        name: "keysightjingce231124",
        component: (resolve) =>
            require(["@/act2023/keysightjingce231124/index.vue"], resolve),
        meta: {
            title: "精测仪器新能源汽车/车载电子",
        },
    },
    // 精测视频
    {
        path: "/keysightjingce231124/videos",
        name: "keysightjingce231124videos",
        component: (resolve) =>
            require(["@/act2023/keysightjingce231124/videos.vue"], resolve),
        meta: {
            title: "精测仪器新能源汽车/车载电子",
        },
    },
    // 信果视频
    {
        path: "/keysightguo231124/videos",
        name: "keysightguo231124videos",
        component: (resolve) =>
            require(["@/act2023/keysightguo231124/videos.vue"], resolve),
        meta: {
            title: "上海信果电源模块和功率器件评估",
        },
    },
    //东方中科视频
    {
        path: "/keysightzhong231124/videos",
        name: "keysightzhong231124videos",
        component: (resolve) =>
            require(["@/act2023/keysightzhong231124/videos.vue"], resolve),
        meta: {
            title: "东方中科分流器,绝缘材料与传感器的测试",
        },
    },
    // 是德EXR示波器——混合信号测试的御林军刀
    {
        path: "/keysight231211/index",
        name: "keysight231211",
        component: (resolve) =>
            require(["@/act2023/keysight231211/index.vue"], resolve),
        meta: {
            title: "参与是德问卷，获取演讲资料",
        },
    },
    {
        path: "/keysight231211/download",
        name: "keysight231211Download",
        component: (resolve) =>
            require(["@/act2023/keysight231211/download"], resolve),
        meta: {
            title: "keysight直播演讲资料下载",
        },
    },
];

export default Act2022;
